import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store/index';
// import Admin from './views/Admin.vue';

Vue.use(Router);

// export default new Router({
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
      // component: () => import('./views/Admin.vue'),
      beforeEnter: (to, from, next) => {
        if (store.state.auth.user.role === 'limited_editor') next('/events');
        else next();
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/auth/signup',
      name: 'signup',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/sign-up.vue'),
    },
    {
      path: '/auth/confirmCode/:email/:code',
      name: 'confirm signup',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/confirm-sign-up.vue'),
      props: true,
    },
    {
      path: '/auth/forgotpassword',
      name: 'forgot password',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/forgot-password.vue'),
    },
    {
      path: '/terms-of-use',
      name: 'terms',
      component: () => import(/* webpackChunkName: "auth" */ './views/auth/terms.vue'),
    },
    {
      path: '/users',
      name: 'users list',
      component: () => import(/* webpackChunkName: "users" */ './views/users/List.vue'),
      beforeEnter: (to, from, next) => {
        if (store.state.auth.user.role === 'limited_editor') next('/');
        else next();
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/users/:userId/edit',
      name: 'users edit',
      component: () => import(/* webpackChunkName: "users" */ './views/users/Edit.vue'),
      props: true,
      beforeEnter: (to, from, next) => {
        if (store.state.auth.user.role === 'limited_editor') next('/');
        else next();
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/users/:userId',
      name: 'users detail',
      component: () => import(/* webpackChunkName: "users" */ './views/users/Detail.vue'),
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/partners',
      name: 'organizations list',
      component: () => import(/* webpackChunkName: "organizations" */ './views/partners/List.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/partners/create',
      name: 'org create',
      component: () => import(/* webpackChunkName: "organizations" */ './views/partners/Edit.vue'),
      props: { create: true },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/partners/:orgId',
      name: 'org detail',
      component: () => import(/* webpackChunkName: "organizations" */ './views/partners/Detail.vue'),
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/partners/:orgId/edit',
      name: 'org edit',
      component: () => import(/* webpackChunkName: "organizations" */ './views/partners/Edit.vue'),
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/partners/joinRequest/:requestId',
      name: 'org join request',
      component: () => import(/* webpackChunkName: "organizations" */ './views/partners/JoinRequest.vue'),
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/cities',
      name: 'city list',
      component: () => import(/* webpackChunkName: "cities" */ './views/cities/CityList.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin' || userRole === 'editor' || userRole === 'dmo') next();
        else next('/');
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/cities/:cityId',
      name: 'city detail',
      component: () => import(/* webpackChunkName: "cities" */ './views/cities/CityDetail.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin' || userRole === 'editor' || userRole === 'dmo') next();
        else next('/');
      },
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/cities/:cityId/edit',
      name: 'city edit',
      component: () => import(/* webpackChunkName: "cities" */ './views/cities/CityEdit.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin' || userRole === 'editor' || userRole === 'dmo') next();
        else next('/');
      },
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/events',
      name: 'event list',
      component: () => import(/* webpackChunkName: "events" */ './views/events/List.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/events/create',
      name: 'event create',
      component: () => import(/* webpackChunkName: "events" */ './views/events/Edit.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/events/:eventId',
      name: 'event detail',
      component: () => import(/* webpackChunkName: "events" */ './views/events/Detail.vue'),
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/events/:eventId/edit',
      name: 'event edit',
      component: () => import(/* webpackChunkName: "events" */ './views/events/Edit.vue'),
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/locations',
      name: 'locations list',
      component: () => import(/* webpackChunkName: "locations" */ './views/locations/List.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/locations/create',
      name: 'locations create',
      component: () => import(/* webpackChunkName: "locations" */ './views/locations/Edit.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/locations/:locationId',
      name: 'locations detail',
      component: () => import(/* webpackChunkName: "locations" */ './views/locations/Detail.vue'),
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/locations/:locationId/edit',
      name: 'locations edit',
      component: () => import(/* webpackChunkName: "locations" */ './views/locations/Edit.vue'),
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/alerts/create',
      name: 'alert create',
      component: () => import(/* webpackChunkName: "events" */ './views/alerts/Edit.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/alerts/:alertId/edit',
      name: 'alert edit',
      component: () => import(/* webpackChunkName: "alerts" */ './views/alerts/Edit.vue'),
      props: true,
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/alerts',
      name: 'alerts list',
      component: () => import(/* webpackChunkName: "alerts" */ './views/alerts/List.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/social-networks',
      name: 'social networks list',
      component: () => import(/* webpackChunkName: "social-networks" */ './views/socialNetworks/List.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/social-networks/create',
      name: 'social networks create',
      component: () => import(/* webpackChunkName: "social-networks" */ './views/socialNetworks/Edit.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      props: { create: true },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/social-networks/:netId',
      name: 'social networks detail',
      component: () => import(/* webpackChunkName: "social-networks" */ './views/socialNetworks/Detail.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/social-networks/:netId/edit',
      name: 'social networks edit',
      component: () => import(/* webpackChunkName: "social-networks" */ './views/socialNetworks/Edit.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/badges',
      name: 'badges list',
      component: () => import(/* webpackChunkName: "badges" */ './views/badges/List.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/badges/create',
      name: 'badges create',
      component: () => import(/* webpackChunkName: "badges" */ './views/badges/Edit.vue'),
      props: { create: true },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/badges/:badgeId/edit',
      name: 'badges edit',
      component: () => import(/* webpackChunkName: "badges" */ './views/badges/Edit.vue'),
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/roadtrips',
      name: 'roadtrips list',
      component: () => import(/* webpackChunkName: "roadtrips" */ './views/roadtrips/List.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/roadtrips/:roadtripId/edit',
      name: 'roadtrip edit',
      component: () => import(/* webpackChunkName: "alerts" */ './views/roadtrips/Edit.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/roadtrips/create',
      name: 'roadtrip create',
      component: () => import(/* webpackChunkName: "events" */ './views/roadtrips/Edit.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/dishes',
      name: 'dishes list',
      component: () => import(/* webpackChunkName: "dishes" */ './views/dishes/List.vue'),
      beforeEnter: (to, from, next) => {
        const userRole = store.state.auth.user.role;
        if (userRole === 'admin') next();
        else next('/');
      },
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/dishes/create',
      name: 'dishes create',
      component: () => import(/* webpackChunkName: "dishes" */ './views/dishes/Edit.vue'),
      props: { create: true },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/dishes/:dishId/edit',
      name: 'dishes edit',
      component: () => import(/* webpackChunkName: "dishes" */ './views/dishes/Edit.vue'),
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['auth/isLoggedIn'].user) {
      next();
      return;
    }
    next('/');
  } else {
    next();
  }
});

export default router;
